<template>
  <div>
    <div class="header">
      <h1 class="page-title">印刷产品订单</h1>
    </div>
    <el-card class="box-card">
      <div class="exportBox">
        <a
          :href="baseUrl+`/api/order/index/uid/${uId}/daike/1/explode/1${status==''?'':`/status/${status}`}${keywords==''?'':`/keywords/${keywords}`}
          ${mindate==''?'':`/mindate/${mindate}`}${maxdate==''?'':`/maxdate/${maxdate}`}`"
          class="export"
          target="_blank"
        >导出Excel</a>
      </div>
      <div slot="header" class="clearfix">
        <ul class="menuItems clearfix">
          <li @click="Allorder()">
            <a>全部订单</a>
          </li>
          <li v-for="item in orderStatusList" :key="item.status" @click="selectOrder(item.status)">
            <a>{{item.nickname}}</a>
          </li>
        </ul>
        <div class="block">
          <span>下单日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="searchOrder()">搜索</button>
          <div class="sy-zongj">
            <span>
              总订单数:
              <b>{{countOrder}}</b>条
            </span>
            <span>
              总金额:
              <b>{{countMoney}}</b>元
            </span>
          </div>
        </div>
      </div>

      <div class="main" style="width:100%; overflow-x: auto; overflow-y: hidden;">
        <table
          cellpadding="0"
          cellspacing="0"
          class="orderTab"
          v-loading="loading"
          style="width:101%; table-layout: fixed;;"
        >
          <thead>
            <td width="30">序号</td>
            <td width="55">客户简称</td>
            <th width="85">订单号</th>
            <th width="80">子单号</th>
            <th width="80">包数</th>
            <th width="90">产品名称</th>
            <th width="180">规格</th>
            <th width="220">文件名</th>
            <th width="70">产品金额</th>
            <th width="70">总运费</th>
            <th width="70">总重量(kg)</th>
            <th width="50">优惠金额</th>
            <th width="100">总金额</th>
            <th width="100">支付方式</th>
            <th width="90">实付金额</th>
            <th width="50">订单状态</th>
            <th width="120">物流单号</th>
            <th width="80">物流方式</th>
            <th width="90">支付时间</th>
            <th width="80">包装费</th>
            <th width="95">操作</th>
          </thead>
          <template v-if="JSON.stringify(orderListData) !='[]'">
            <tbody
              :class="[item.length==1?'':'orange']"
              v-for="(item,index) in orderListData"
              :key="index"
            >
              <!-- 未合包布局 -->

              <template v-if="item.length==1">
                <tr>
                  <td>{{indexMethod(index)}}</td>
                  <td width="35">{{item[0].jname}}</td>
                  <td width="85">{{item[0].order_no}}</td>
                  <td></td>
                  <td>1</td>
                  <td>{{item[0].product_name}}</td>
                  <td>{{item[0].title}}</td>
                  <td>
                    
                    <div v-if="item[0].status_str=='未下载'||item[0].status_str=='未付款'">
                      <div class="f">
                        <form name="theform">
                          <input
                            style="display:none"
                            type="radio"
                            name="myradio"
                            value="local_name"
                          />
                          <input
                            style="display:none"
                            type="radio"
                            name="myradio"
                            value="random_name"
                            checked="true"
                          />
                          <input
                            style="display:none"
                            type="text"
                            id="dirname"
                            :value="filePath"
                            size="50"
                          />
                        </form>
                        <div :id="item[0].id" class="contaniner">
                          <p>
                            <a
                              id="selectfiles"
                              href="javascript:void(0);"
                              class="cz xq"
                              style="display:none"
                            >更换文件</a>
                            <span
                              class="venifyFile"
                              @click.stop="venifyFile(item[0].id,$event)"
                            >更换文件</span>
                            <span v-if="item[0].replace!=0">
                              已更换
                              <i class="sy_count">{{item[0].replace}}</i> 次
                            </span>
                          </p>
                          {{item[0].file}}
                        </div>
                        <div class="ossfile"></div>
                      </div>
                    </div>
                    <div
                      v-else-if="(item[0].status_str=='待发货' || item[0].status_str=='替换中') && item[0].date.includes(dF)"
                    >
                      <p>
                        <a
                          v-if="item[0].filebhstr==''"
                          @click="replaceFile(item[0])"
                          href="javascript:void(0);"
                          class="cz qx"
                        >申请替换</a>
                        <a
                          v-else-if="item[0].filebhstr=='申请中'"
                          href="javascript:void(0);"
                          class="cz sh"
                        >申请中</a>
                        <a
                          v-else-if="item[0].filebhstr=='已批准'"
                          href="javascript:void(0);"
                          class="czs ypz"
                        >已批准</a>
                        <a v-else href="javascript:void(0);" class="cz yj shou">已驳回</a>
                        <span v-if="item[0].replace!=0">
                          已更换
                          <i class="sy_count">{{item[0].replace}}</i> 次
                        </span>
                      </p>
                      {{item[0].file}}
                    </div>

                    <div v-else>{{item[0].file}}</div>
                    <a target="_blank" class="cz xq" :href="item[0].filename">下载文件</a>
                  </td>
                  <td>{{item[0].goods_price}}</td>
                  <td>{{item[0].total_shipping_fee}}</td>
                  <td>{{item[0].total_weight + 'kg'}}</td>
                  <td>0</td>
                  <td>{{item[0].total_price}}</td>
                  <td>{{item[0].payway}}</td>
                  <td>{{item[0].realy_price}}</td>
                  <td>
                    <el-tag
                      type="danger"
                      effect="dark"
                      v-if="item[0].status_str=='售后'"
                    >{{item[0].status_str}}</el-tag>
                    <template v-else>{{item[0].status_str}}</template>
                  </td>
                  <td>{{item[0].erpno!=null ? item[0].erpno : '暂无单号'}}</td>
                  <td>
                    {{item[0].express_name}}
                    <button
                      v-if="item[0].erpno!=null"
                      class="cz wl"
                      @click="getWuLiu(item[0].order_no)"
                    >物流轨迹</button>
                  </td>
                  <td>{{item[0].createtime|dateFormat}}</td>
                  <td>{{item[0].packprice}}</td>
                  <td>
                    <div v-if="item[0].status_str=='未下载'">
                      <button class="cz xq" @click="orderDetail(item[0].order_no)">订单详情</button>
                      <button class="cz qx" @click="cancelOrder(item[0].order_no)">取消订单</button>
                    </div>
                    <div v-else-if="item[0].status_str=='未付款'">
                      <button class="cz xq" @click="orderDetail(item[0].order_no)">订单详情</button>
                      <button class="cz qx" @click="cancelOrder(item[0].order_no)">取消订单</button>
                      <el-button
                        style="margin-left:5px"
                        size="mini"
                        type="success"
                        @click="paymentOrder(item[0])"
                      >支付</el-button>
                    </div>
                    <div v-else>
                      <button class="cz xq" @click="orderDetail(item[0].order_no)">订单详情</button>
                      <button class="cz zl" @click="goDetail(item[0].product_id)">再来一单</button>
                      <button
                        class="cz sx"
                        v-if="item[0].shstr=='申请取消'&&item[0].qxstr==''"
                        @click="applyCancelOrder(item[0].id,item[0].product_id,item[0].total_price)"
                      >申请取消</button>
                      <button
                        class="czs sqx"
                        v-else-if="item[0].shstr=='申请取消'&&item[0].qxstr=='申请取消中'"
                      >正在申请中</button>
                      <button
                        v-else-if="item[0].status_str!='售后'"
                        class="cz sh"
                        @click="goBackOrder(item[0].id)"
                      >申请售后</button>
                      <button v-else class="cz yj shou">售后</button>
                    </div>
                  </td>
                </tr>
              </template>
              <!-- 合包布局 -->
              <template v-else>
                <template v-for="(item1,index1) in item">
                  <tr v-if="index1==0" :key="index1">
                    <td :rowspan="item.length">{{indexMethod(index)}}</td>
                    <td :rowspan="item.length">{{item1.jname}}</td>
                    <td :rowspan="item.length">{{item1.order_no}}</td>
                    <td>{{item1.pack}}</td>
                    <td :rowspan="item.length">{{item1.packnum}}</td>
                    <td>{{item1.product_name}}</td>
                    <td>{{item1.title}}</td>
                    <td>
                       
                      <div v-if="item1.status_str=='未下载'||item[0].status_str=='未付款'">
                        <div class="f">
                          <form name="theform">
                            <input
                              style="display:none"
                              type="radio"
                              name="myradio"
                              value="local_name"
                            />
                            <input
                              style="display:none"
                              type="radio"
                              name="myradio"
                              value="random_name"
                              checked="true"
                            />
                            <input
                              style="display:none"
                              type="text"
                              id="dirname"
                              :value="filePath"
                              size="50"
                            />
                          </form>
                          <div :id="item1.id" class="contaniner">
                            <p>
                              <a
                                id="selectfiles"
                                href="javascript:void(0);"
                                class="cz xq"
                                style="display:none"
                              >更换文件</a>

                              <span
                                class="venifyFile"
                                @click.stop="venifyFile(item1.id,$event)"
                              >更换文件</span>
                              <span v-if="item1.replace!=0">
                                已更换
                                <i class="sy_count">{{item1.replace}}</i> 次
                              </span>
                            </p>
                            {{item1.file}}
                          </div>
                          <div class="ossfile"></div>
                        </div>
                      </div>
                      <div
                        v-else-if="(item1.status_str=='待发货'||item1.status_str=='替换中') && item1.date.includes(dF)"
                      >
                        <p>
                          <a
                            href="javascript:void(0);"
                            @click="replaceFile(item1)"
                            class="cz qx"
                            v-if="item1.filebhstr==''"
                          >申请替换</a>
                          <a
                            href="javascript:void(0);"
                            class="cz sh"
                            v-else-if="item1.filebhstr=='申请中'"
                          ></a>

                          <a
                            v-else-if="item1.filebhstr=='已批准'"
                            href="javascript:void(0);"
                            class="czs ypz"
                          >已批准</a>

                          <a v-else href="javascript:void(0);" class="cz yj shou">已驳回</a>
                          <span v-if="item1.replace!=0">
                            已更换
                            <i class="sy_count">{{item1.replace}}</i> 次
                          </span>
                        </p>
                        {{item1.file}}
                      </div>

                      <div v-else>{{item1.file}}</div>
                      <a target="_blank" class="cz xq" :href="item1.filename">下载文件</a>
                    </td>
                    <td>{{item1.goods_price}}</td>
                    <td :rowspan="item.length">{{item[0].total_shipping_fee}}</td>
                    <td :rowspan="item.length">{{item[0].total_weight + 'kg'}}</td>
                    <td>0</td>
                    <td :rowspan="item.length">{{item[0].total_price}}</td>
                    <td :rowspan="item.length">{{item[0].payway}}</td>
                    <td :rowspan="item.length">{{item[0].realy_price}}</td>
                    <td>
                      <el-tag
                        type="danger"
                        effect="dark"
                        v-if="item[0].status_str=='售后'"
                      >{{item[0].status_str}}</el-tag>
                      <template v-else>{{item1.status_str}}</template>
                    </td>
                    <td>{{item1.erpno!=null ? item1.erpno : '暂无单号'}}</td>
                    <td :rowspan="item.length">
                      {{item1.express_name}}
                      <button
                        v-if="item1.erpno!=null"
                        class="cz wl"
                        @click="getWuLiu(item1.order_no)"
                      >物流轨迹</button>
                    </td>
                    <td :rowspan="item.length">{{item1.createtime|dateFormat}}</td>
                    <td>
                      {{item1.packprice}}
                    </td>
                    <td :rowspan="item.length">
                      <div v-if="item1.shstr=='申请取消'">
                        <button class="cz xq" @click="orderDetail(item1.order_no)">订单详情</button>
                        <button
                          v-if="item1.qxstr==''&&item1.shstr=='申请取消'"
                          class="cz sx"
                          @click="applyCancelOrder(item.ids,item1.product_id,item1.total_price)"
                        >申请取消</button>
                        <button
                          class="czs sqx"
                          v-else-if="item1.shstr=='申请取消'&&item[0].qxstr=='申请取消中'"
                        >正在申请中</button>
                      </div>
                      <div v-else-if="item1.status_str=='未下载'">
                        <button class="cz xq" @click="orderDetail(item1.order_no)">订单详情</button>
                        <button class="cz qx" @click="cancelOrder(item1.order_no)">取消订单</button>
                      </div>
                      <div v-else-if="item1.status_str=='未付款'">
                        <button class="cz xq" @click="orderDetail(item1.order_no)">订单详情</button>
                        <button class="cz qx" @click="cancelOrder(item1.order_no)">取消订单</button>
                        <el-button
                          style="margin-left:5px"
                          size="mini"
                          type="success"
                          @click="paymentOrder(item1)"
                        >支付</el-button>
                      </div>
                      <div v-else>
                        <button class="cz xq" @click="orderDetail(item1.order_no)">订单详情</button>
                        <button class="cz zl" @click="goDetail(item1.product_id)">再来一单</button>
                        <button class="cz sh" @click="goBackOrder(item1.order_no,1)">申请售后</button>
                      </div>
                    </td>
                  </tr>
                  <tr v-else>
                    <td>{{item1.pack}}</td>
                    <td>{{item1.product_name}}</td>
                    <td>{{item1.title}}</td>
                    <td>
                      <div v-if="item1.status_str=='未下载'||item[0].status_str=='未付款'">
                        <div class="f">
                          <form name="theform">
                            <input
                              style="display:none"
                              type="radio"
                              name="myradio"
                              value="local_name"
                            />
                            <input
                              style="display:none"
                              type="radio"
                              name="myradio"
                              value="random_name"
                              checked="true"
                            />
                            <input
                              style="display:none"
                              type="text"
                              id="dirname"
                              :value="filePath"
                              size="50"
                            />
                          </form>
                          <div :id="item1.id" class="contaniner">
                            <p>
                              <a
                                id="selectfiles"
                                href="javascript:void(0);"
                                class="cz xq"
                                style="display:none"
                              >更换文件</a>
                              <span
                                class="venifyFile"
                                @click.stop="venifyFile(item1.id,$event)"
                              >更换文件</span>
                              <span v-if="item1.replace!=0">
                                已更换
                                <i class="sy_count">{{item1.replace}}</i> 次
                              </span>
                            </p>
                            {{item1.file}}
                          </div>
                          <div class="ossfile"></div>
                        </div>
                      </div>
                      <div
                        v-else-if="(item1.status_str=='待发货'||item1.status_str=='替换中') && item1.date.includes(dF)"
                      >
                        <p>
                          <a
                            href="javascript:void(0);"
                            @click="replaceFile(item1)"
                            class="cz qx"
                            v-if="item1.filebhstr==''"
                          >申请替换</a>
                          <a
                            href="javascript:void(0);"
                            class="cz sh"
                            v-else-if="item1.filebhstr=='申请中'"
                          ></a>
                          <a
                            v-else-if="item1.filebhstr=='已批准'"
                            href="javascript:void(0);"
                            class="czs ypz"
                          >已批准</a>
                          <a v-else href="javascript:void(0);" class="cz yj shou">已驳回</a>
                          <span v-if="item1.replace!=0">
                            已更换
                            <i class="sy_count">{{item1.replace}}</i> 次
                          </span>
                        </p>
                        {{item1.file}}
                      </div>
                      <div v-else>{{item1.file}}</div>
                    </td>
                    <td>{{item1.goods_price}}</td>
                    <td>0</td>
                    <td>
                      <el-tag
                        type="danger"
                        effect="dark"
                        v-if="item[0].status_str=='售后'"
                      >{{item[0].status_str}}</el-tag>
                      <template v-else>{{item1.status_str}}</template>
                    </td>
                    <td>{{item1.erpno!=null ? item1.erpno : '暂无单号'}}</td>

                    <td>
                      {{item1.packprice}}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
          <div class="zw" v-else>暂无数据</div>
        </table>

        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="pageCount"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
      <el-drawer title="订单详情" :visible.sync="drawer" direction="rtl" size="60%" destroy-on-close>
        <div v-loading="loading">
          <div class="parmengInfo">
            <ul class="clearfix">
              <li class="sy_one">
                <span class="borderTop"></span>
                <div class="itemBox">
                  <div class="infoTitle">收货人信息</div>
                  <div class="sy-content">
                    <p>
                      收货人：
                      <span>{{spinfo.name}}</span>
                    </p>
                    <p>
                      现地址：
                      <span>{{spinfo.address}}</span>
                    </p>
                    <p>
                      手机号：
                      <span>{{spinfo.phone}}</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="sy_two">
                <span class="borderTop"></span>
                <div class="itemBox">
                  <div class="infoTitle">配送信息</div>
                  <div class="sy-content">
                    <p>
                      配送方式：
                      <span>{{psinfo.express_id}}</span>
                    </p>
                    <p>
                      快递运费：
                      <span>{{psinfo.shipping_fee}}</span>
                    </p>
                    <p>
                      快递单号：
                      <span>{{psinfo.kdcode}}</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="sy_three">
                <span class="borderTop"></span>
                <div class="itemBox">
                  <div class="infoTitle">付款信息</div>
                  <div class="sy-content">
                    <p>
                      付款方式：
                      <span>{{priceinfo.pay_way}}</span>
                      &nbsp; &nbsp; &nbsp; &nbsp; 优惠金额：
                      <span>{{'￥'+priceinfo.discount_fee}}</span>
                    </p>
                    <p>
                      运费金额：
                      <span>{{'￥'+priceinfo.shipping_fee}}</span>
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 产品总额：
                      <span>{{'￥'+goods_price}}</span>
                    </p>
                    <p>
                      实付金额：
                      <span>{{'￥'+priceinfo.total_price}}</span>
                    </p>
                  </div>
                </div>
              </li>
              <li class="sy_focu">
                <span class="borderTop"></span>
                <div class="itemBox">
                  <div class="infoTitle">发票信息</div>
                  <p>暂无</p>
                </div>
              </li>
            </ul>
          </div>
          <el-table :data="orderDetailInfo.data" border style="width: 100%">
            <el-table-column prop="product_name" label="产品名称"></el-table-column>
            <el-table-column prop="title" label="规格" width="300"></el-table-column>
            <el-table-column prop="filename" width="350" label="文件名">
              <template slot-scope="scope">{{scope.row.filename.slice(77)}}</template>
            </el-table-column>
            <el-table-column prop="goods_price" label="产品金额"></el-table-column>
            <el-table-column prop="number" label="数量"></el-table-column>
            <el-table-column prop="discount_fee" label="优惠金额">
              <template
                slot-scope="scope"
              >{{!scope.row.discount_fee ? '0' : scope.row.discount_fee}}</template>
            </el-table-column>
          </el-table>
          <!-- 订单日志 -->
          <el-table :data="orderrZhi" border style="width: 100%;margin-top:20px">
            <el-table-column prop="order_no" label="订单号" width="300"></el-table-column>
            <el-table-column prop="createtime" label="操作时间" width="300">
              <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
            </el-table-column>
            <el-table-column prop="remark" width="350" label="备注"></el-table-column>
            <el-table-column prop="status_str" label="状态"></el-table-column>
          </el-table>
        </div>
      </el-drawer>
    </el-card>
    <el-dialog title="支付" :visible.sync="dialogVisible" width="37%">
      <div class="methods">
        <ul class="clearfix method-box">
          <li class="current" id="1">
            <a href="javascript:void(0);" class="balanceBox">
              <span class="balanceInfo">
                余额:
                <i>{{yue+'元'}}</i>
              </span>
              <img src="../../../assets/order/balance.png" alt="余额支付" />
            </a>
          </li>
          <li id="2" v-if="AliPay">
            <a href="javascript:void(0);">
              <img src="../../../assets/order/Alipay.png" alt="支付宝支付" />
            </a>
          </li>
          <li id="3" v-if="WeChatPay">
            <a href="javascript:void(0);">
              <img src="../../../assets/order/weChat.png" alt="微信支付" />
            </a>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="zhifu">支 付</el-button>
      </span>
    </el-dialog>
    <!-- <download-excel
      id="exportTable"
      class="btn btn-default"
      :data="orderListData"
      :fields="json_fields"
      worksheet="My Worksheet"
      type="xls"
      name="订单.xls"
    >导出excel</download-excel>-->
    <div class="message">
      <p>订单列表默认显示当天，你可通过时间搜索</p>
    </div>
    <!-- 物流轨迹 -->
    <el-dialog
      title="物流轨迹"
      :visible.sync="WLdialog"
      width="60%"
      v-loading="wlLoading"
      element-loading-text="正在获取物流信息~~~"
    >
      <!-- 物流轨迹 -->
      <div class="wuliu-guiji" v-if="JSON.stringify(WLdate)!=='[]'">
        <div class="box-in" v-for="(item,index) in WLdate" :key="index">
          <div class="clearfix wl_tit">
            <p class="wuliu-title">物流轨迹</p>
            <div class="sy_fr">
              <p>快递方式：{{item[0].express_name}}</p>
              <p>快递单号：{{item[0].kd_code}}</p>
            </div>
          </div>
          <div class="block">
            <el-timeline>
              <el-timeline-item v-for="(activity, index) in item" :key="index" color="#0bbd87">
                <div class="wuliu-new">
                  <p class="wuliu-new-top">{{activity.AcceptTime}}</p>
                  <ul>
                    <li>{{activity.AcceptStation}}</li>
                  </ul>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <div class="sy_ww" v-else>暂无最新物流信息</div>
    </el-dialog>
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel'

import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'
let thatt = ''
let f = false
let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  // len = len || 32;
  // var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  // var maxPos = chars.length;
  // var pwd = '';
  // for (i = 0; i < len; i++) {
  //     pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  // }

  // $(window.Fname)
  //   .parents('.title')
  //   .siblings('.shangpin-info')
  //   .find('.left p')
  //   .text() +
  // '-' +
  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}
function upit(index, el) {
  let uploader = new plupload.Uploader({
    id: index,
    runtimes: 'html5,flash,silverlight,html4',
    browse_button: el,
    // multi_selection: false,
    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
    // chunk_size: 1024 * 1024 * 5, 是否分片上传
    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
    url: 'http://oss.aliyuncs.com',
    filters: {
      mime_types: [
        // 限制可上传的文件格式
        { title: 'Image files', extensions: 'jpg' },
        { title: 'Zip files', extensions: 'zip' },
        { title: 'Rar files', extensions: 'rar' },
        { title: 'Cdr files', extensions: 'cdr' }
      ]
    },
    init: {
      PostInit: function() {
        $('.ossfile')
          .eq(index)
          .text('')
      },

      FilesAdded: function(up, files) {
        $('.ossfile')
          .eq(index)
          .show()
        window.Fname = $(el)
          .parents('.f')
          .siblings('.title')
          .find('.check')[0]
        set_upload_param(uploader, '', false)

        plupload.each(files, function(file) {
          let ossFile = $(el)
            .parents('.contaniner')
            .siblings('.ossfile')
          ossFile.html(
            '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>' +
              '</div>'
          )
        })
      },
      BeforeUpload: function(up, file) {
        check_object_radio()
        get_dirname()
        set_upload_param(up, file.name, true)
      },

      UploadProgress: function(up, file) {
        var d = document.getElementById(file.id)
        d.getElementsByTagName('b')[0].innerHTML =
          '<span>' + file.percent + '%</span>'
        var prog = d.getElementsByTagName('div')[0]
        var progBar = prog.getElementsByTagName('div')[0]
        progBar.style.width = 2.9 * file.percent + 'px'
        progBar.setAttribute('aria-valuenow', file.percent)
      },

      FileUploaded: async function(up, file, info) {
        if (info.status == 200) {
          let order_id = $(el)
            .parents('.contaniner')
            .attr('id')
          let filenamee =
            'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)
          let param = new URLSearchParams()
          param.append('id', order_id)
          const { data: res } = await thatt.$http({
            method: 'post',
            url: 'api/files/findFlieStatus',
            data: param
          })
          if (res.code) {
            $.ajax({
              type: 'post',
              url: url + '/api/order/replacefile',
              data: {
                id: order_id,
                filename: filenamee,
                file: file.name,
                token: window.localStorage.getItem('token')
              },
              dataType: 'json',
              success: function(res) {
                if (res.code == 1) {
                  $(el)
                    .parent('.contaniner')
                    .siblings('.ossfile')
                    .hide()
                  f = true
                  thatt.$confirm('更换文件成功!', '提示')
                  $(el)
                    .parents('.contaniner')
                    .siblings('.ossfile')
                    .hide()
                } else {
                  alert('上传失败')
                }
              }
            })
          } else {
            thatt.$confirm('更换失败，' + res.msg, '提示')
          }
          thatt.queryOrderList()
        } else {
          alert('上传出错了')
        }
      },

      Error: function(up, err) {
        alert('出错了！')
        window.location.reload()
      }
    }
  })

  uploader.init()
}

export default {
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      dF: new Date().toLocaleDateString(),
      drawer: false,
      json_fields: {
        订单号: {
          field: 'order_no',
          callback: value => {
            value = value.split('')
            value.unshift('`')
            value.push('`')
            return value.join('')
          }
        },
        产品名称: 'product_name',
        规格: 'title',
        文件名: 'file',
        产品金额: 'goods_price',
        运费: 'shipping_fee',
        优惠金额: 'total_fee',
        应付金额: {
          field: 'total_price',
          callback: value => {
            return value.toFixed(2)
          }
        },
        订单状态: 'status_str',
        物流方式: 'express_name',
        下单时间: {
          field: 'createtime',
          callback: originVal => {
            const dt = new Date(originVal * 1000)

            const y = dt.getFullYear()
            const m = (dt.getMonth() + 1 + '').padStart(2, '0')
            const d = (dt.getDate() + '').padStart(2, '0')

            const hh = (dt.getHours() + '').padStart(2, '0')
            const mm = (dt.getMinutes() + '').padStart(2, '0')
            const ss = (dt.getSeconds() + '').padStart(2, '0')

            return `${y} - ${m} - ${d} ${hh}:${mm}:${ss}`
          }
        }
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: '',
      //   订单状态列表
      orderStatusList: [],
      orderListData: [],
      token: window.localStorage.getItem('token'),
      page: 1,
      keywords: '',
      loading: true,
      pageCount: 1,
      status: '',
      mindate:
        new Date().toLocaleDateString().replace(/\//g, '-') + ' 00:00:00',
      maxdate:
        new Date().toLocaleDateString().replace(/\//g, '-') + ' 23:59:59',
      countOrder: 0,
      countMoney: 0,
      orderDetailInfo: [],
      orderPrice: [],
      goods_price: '',
      shipping_fee: '',
      total_price: '',
      spinfo: [],
      psinfo: [],
      priceinfo: [],
      filePath: '',
      loading: 'true',
      orderrZhi: [],
      flag: false,
      yue: '',
      dialogVisible: false,
      zhifuInfo: {
        token: window.localStorage.getItem('token'),
        order_pid: '',
        amount: '',
        payway: 1
      },
      wlLoading: false,
      WLdate: [],
      WLdialog: false,
      baseUrl: '',
      uId: '',
      WeChatPay: false,
      AliPay: false
    }
  },
  created() {
    let url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    if (window.sessionStorage.getItem('status')) {
      this.status = window.sessionStorage.getItem('status')
    } else {
      this.status = ''
    }
    window.sessionStorage.removeItem('status')

    this.queryOrderStatus()
    this.queryOrderList()
    let u = JSON.parse(window.localStorage.getItem('u'))

    this.uId = u.id
    this.filePath =
      'uploads/' +
      u.mobile +
      '/' +
      new Date().toLocaleDateString().replace(/\//g, '-')
  },
  methods: {
    // 支付方式
    async queryPayMethods() {
      const { data: res } = await this.$http.get('api/index/payway')
      this.WeChatPay = res.data[3]
      this.AliPay = res.data[2]
    },
    async getWuLiu(order_no) {
      this.WLdialog = true
      this.wlLoading = true
      let p = new URLSearchParams()
      p.append('order_no', order_no)
      const { data: res } = await this.$http.post('api/order/express', p)
      if (res) {
        this.wlLoading = false
        if (res.data === null) {
          this.WLdate = []
        } else {
          this.WLdate = res.data
        }
      }
    },
    venifyFile(id, e) {
      const that = this
      $.ajax({
        type: 'post',
        url: url + '/api/order/checkfile',
        data: { id, id },
        dataType: 'json',
        async: false,
        success: function(res) {
          if (!res.code || res.msg == '可申请') {
            thatt.$confirm(
              '文件已被下载，不可替换,如要更换文件，请申请',
              '提示'
            )
            thatt.queryOrderList()
          } else {
            let span = e.target
            let aa = $(span)
              .siblings('div')
              .find('input')[0]
            aa.click()
          }
        }
      })
    },
    goDetail(id) {
      this.$router.push('/detail?id=' + id)
    },
    async paymentOrder(item) {
      this.queryPayMethods()
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('order_no', item.order_no)
      const { data: res } = await this.$http.post('api/pays/repay', param)
      this.zhifuInfo.order_pid = res.data.order_pid
      this.zhifuInfo.amount = item.realy_price
      const that = this
      this.dialogVisible = true
      if (!this.flag) {
        this.$nextTick(_ => {
          that.flag = true
          $('.el-dialog .el-dialog__body .methods .method-box li').click(
            function() {
              $(this)
                .addClass('current')
                .siblings('li')
                .removeClass('current')
              that.zhifuInfo.payway = $(this).attr('id')
            }
          )
        })
      }
    },
    async zhifu() {
      let param = new URLSearchParams()
      for (let k in this.zhifuInfo) {
        param.append(k, this.zhifuInfo[k])
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/pays/submit',
        data: param
      })
      if (res.code != undefined) {
        if (res.code == 1) {
          this.dialogVisible = false
          this.$confirm({
            title: '提示',
            type: 'success',
            message: `支付成功`,
            showClose: false,
            closeOnClickModal: false,
            callback: res => {
              this.queryOrderList()
            }
          })
        } else {
          this.$confirmm(res.msg, '提示', {
            confirmButtonText: '去充值',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$router.push('/recharge')
            })
            .catch(() => {})
        }
      } else {
        const div = document.createElement('div')
        div.innerHTML = res // html code
        document.body.appendChild(div)
        document.forms.alipaysubmit.submit()
      }
    },
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      this.yue = res.data.money
      $('.money span').text(this.yue + '元')
    },
    // 申请取消
    applyCancelOrder(order_id, product_id, total_price) {
      console.log(order_id, product_id, total_price)
  this.$confirmm(
        '此操作将会向商家申请取消该订单，商家同意后订单会被取消，是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(async () => {
          let param = new URLSearchParams()
          param.append('token', window.localStorage.getItem('token'))
          param.append('query', '直接申请取消的理由')
          param.append('product_id', product_id)
          param.append('order_id', order_id)
          param.append('type', '1')
          param.append('querytype', 'qbackmoney')
          param.append('backmoney', 'backmoney')
          param.append('backcate', '4')
          param.append('backimg', '')
          param.append('money', total_price)
          param.append('phone', '')
          param.append('expressno', '')

          const { data: res } = await this.$http({
            url: 'api/backorder/addorder',
            method: 'post',
            data: param
          })
          if (res.code == 1) {
            this.$confirm('已经发起申请，请等待客服同意', '提示')
          } else {
            this.$confirm(res.msg, '提示')
          }
          this.queryOrderList()
        })
        .catch(() => {})
    },
    // 申请替换
    async replaceFile(item) {
      let param = new URLSearchParams()
      param.append('id', item.id)
      param.append('filename', '')
      param.append('file', '')
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/replacefile',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('申请成功,请等待管理员同意', '提示', {
          confirmButtonText: '去查看',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/fileList')
          })
          .catch(() => {
            this.queryOrderList()
          })
      } else {
        this.$confirm(
          '您的替换文件申请已经提交，勿重复提交，请等待客服同意',
          '提示'
        )
      }
    },
    // 申请售后
    goBackOrder(id, status = 0) {
      if (status == 1) {
        this.$router.push('/applysaleback/' + id + '.')
        return
      }
      this.$router.push('/applysaleback/' + id + '')
    },
    // 订单详情
    async orderDetail(order_no) {
      this.orderDetailInfo = []
      this.orderrZhi = []
      this.goods_price = ''
      this.shipping_fee = ''
      this.total_price = ''
      this.spinfo = []
      this.psinfo = []
      this.priceinfo = []
      this.drawer = true
      this.loading = true
      let param = new URLSearchParams()
      param.append('order_no', order_no)
      const { data: resl } = await this.$http({
        method: 'post',
        url: 'api/order/deatil',
        data: param
      })
      const { data: result } = await this.$http({
        method: 'post',
        url: 'api/order/deatilxq',
        data: param
      })
      const { data: ress } = await this.$http({
        method: 'post',
        url: 'api/order/orderlog',
        data: param
      })
      if (ress.code == 1) {
        this.orderrZhi = ress.data
      }
      if (resl.code == 1) {
        this.orderDetailInfo = resl.data
        this.goods_price = resl.data.price.goods_price
        this.shipping_fee = result.data.priceinfo.shipping_fee
        this.total_price = result.data.priceinfo.total_price
      }
      this.spinfo = result.data.spinfo
      this.psinfo = result.data.psinfo
      this.priceinfo = result.data.priceinfo
      this.loading = false
    },
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    // 取消订单
    cancelOrder(id, status = 0) {
      this.$confirmm(
        (!status ? '付款金额将全部返还到您的账户' : '单个取消订单将不退运费') +
          ',确定取消该订单吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(async () => {
          let param = new URLSearchParams()
          if (status == 0) {
            param.append('order_no', id)
          } else if (status == 1) {
            param.append('id', id)
          }

          const { data: res } = await this.$http({
            method: 'post',
            url: 'api/order/cancelorder',
            data: param
          })
          // console.log(res)
          if (res.code == 1) {
            this.$confirm('已经取消该订单', '提示')
          } else {
            this.$confirm(res.msg, '提示')
          }
          this.queryOrderList()
        })
        .catch(() => {})
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    handleCurrentChange(val) {
      this.page = val
      this.queryOrderList()
    },
    async queryOrderStatus() {
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/statuslst'
      })
      if (res.code == 1) {
        this.orderStatusList = res.data
      }
    },
    Allorder() {
      // 让上传控件初始化
      if (f) {
        f = false
      }
      this.value2 = ''
      this.status = ''
      this.keywords = ''
      this.mindate = ''
      this.maxdate = ''
      this.page = 1
      this.queryOrderList()
    },
    // 搜索
    searchOrder() {
      this.queryOrderList()
    },
    selectOrder(status) {
      // 让上传控件初始化
      if (f) {
        f = false
      }
      this.status = status
      this.page = 1
      this.queryOrderList(status)
    },
    //   订单列表
    async queryOrderList(status = this.status) {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('status', status)
      param.append('keywords', this.keywords)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      param.append('daike', 1)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/index',
        data: param
      })
      this.loading = false
      if (res.code == 1) {
        let result = res.data.data
        for (let i = 0; i < result.length; i++) {
          for (let j = 0; j < result[i].length; j++) {
            let m = result[i][j].createtime * 1000
            let date = new Date(m)
            result[i][j].date = date.toLocaleDateString()
          }
        }
        this.orderListData = result

        let toatlMoney = 0
        let toatlYunfei = 0
        for (let i = 0; i < this.orderListData.length; i++) {
          if (this.orderListData[i].length > 1) {
            for (let k = 0; k < this.orderListData[i].length; k++) {
              toatlMoney += this.orderListData[i][k].total_price
              toatlYunfei += this.orderListData[i][k].shipping_fee
            }
            this.orderListData[i].toatlMoney = toatlMoney.toFixed(2)
            this.orderListData[i].toatlYunfei = toatlYunfei.toFixed(2)
          }
        }
        this.pageCount = res.data.page_count * 10
        thatt = this
        // 初始化
        this.$nextTick(_ => {
          if (f == false) {
            setTimeout(() => {
              $.each($('.f #selectfiles'), function(
                indexInArray,
                valueOfElement
              ) {
                upit(indexInArray, valueOfElement)
              })
            }, 500)
          }
        })

        if (res.data.num_count) {
          this.countOrder = res.data.num_count
          this.countMoney = res.data.price_count.toFixed(2)
        } else {
          this.countOrder = 0
          this.countMoney = 0
        }

        // 获取每个荷包订单中的id集合
        for (let k1 in this.orderListData) {
          if (this.orderListData[k1].length > 1) {
            let ids = []
            for (let i = 0; i < this.orderListData[k1].length; i++) {
              ids.push(this.orderListData[k1][i].id)
            }
            this.orderListData[k1].ids = ids.join(',')
          }
        }
        this.getYue()
      }
    }
  },
  mounted() {
    window.sessionStorage.removeItem('cartype')
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
      $(this)
        .siblings('li')
        .children('a')
        .css({ color: '#666', 'border-left': '3px solid #ccc' })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      margin-left: 5px;
      position: relative;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
.parmengInfo {
  margin-bottom: 180px;
  ul {
    display: flex;
    li {
      position: relative;
      float: left;
      margin-right: 20px;
      border: 1px solid #eee;
      box-shadow: 0 0 1px 1px #f0efef;
      border-top: 0;
      .borderTop {
        position: absolute;
        top: 0;
        display: block;
        width: 100%;
        height: 10px;
        background: url('../../../assets/user/border-top.png') no-repeat;
      }
      .itemBox {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 30px 10px 10px;
        .infoTitle {
          font-size: 14px;
          color: #666;
        }
      }
      .sy-content {
        margin-top: 5px;
        font-size: 12px;
        color: #777;
      }
    }
    .sy_one {
      flex: 20%;
    }
    .sy_two {
      flex: 20%;
    }
    .sy_three {
      flex: 30%;
    }
    .sy_focu {
      flex: 30%;
    }
  }
}
.priceInfo {
  margin-top: 30px;
  padding-right: 30px;
  float: right;
  p {
    margin-bottom: 5px;
    font-size: 14px;
    color: #666;
    i {
      font-size: 20px;
      color: #e83030;
    }
  }
}
.message {
  position: absolute;
  top: 250px;
  right: 100px;
  font-size: 16px;
  color: #a77c5a;
  font-weight: bold;
}
.main {
  .orange {
    background-color: #f0fff0;
    border-bottom: 2px solid #a77c5a;
  }
  .orderTab {
    position: relative;
    height: 80px;
    th {
      padding: 10px 5px;
      background-color: #fafafa;
    }

    td {
      padding: 10px 7px;
      border: 1px solid #eee;
      font-size: 12px;
      color: #666;
      word-break: break-all;
    }
    .zw {
      font-size: 18px;
      color: #666;
      text-align: center;
      position: absolute;
      top: 50px;
      right: 750px;
    }
  }
}
.sh,
.qx,
.xq,
.sx,
.yj,
.zl,
.wl {
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  margin-bottom: 5px;
}
.sx {
  background: #606266;
}
.sh {
  background: #67c23a;
}
.qx {
  background: #e6a23c;
}
.xq {
  background: #4da5ff;
}
.yj {
  background: rgba(219, 87, 5, 1);
}
.zl {
  background: #a77c5a;
}
.shou {
  padding: 5px 16px;
}
.wl {
  background: #67c23a;
}
.czs {
  font-size: 12px;
  padding: 5px 3px;
  border-radius: 7px;
}
.sqx {
  background-color: #909399;
  color: #fff;
}
.ypz {
  background-color: #a77c5a;
  color: #fff;
}

.methods {
  margin-top: 12px;
  .method-box {
    padding-left: 30px;
    .balanceBox {
      position: relative;
    }
    .balanceInfo {
      position: absolute;
      right: 25px;
      top: 24px;
      font-size: 12px;
    }
    li {
      position: relative;
      float: left;
      width: 180px;
      height: 72px;
      margin-right: 20px;
      a {
        display: block;
        height: 100%;
        line-height: 72px;
        box-shadow: 1px 1px 6px 2px #eee;
        text-align: center;
      }
      a:hover {
        border: 1px solid #a77c5a;
      }
    }
  }
  .current {
    background: url('../../../assets/order/duigou.png') no-repeat right bottom;
  }
}
.sy_count {
  color: #e83030;
  font-weight: bold;
}
.contaniner {
  p {
    .venifyFile {
      z-index: auto;
      margin-left: 5px;
      padding: 5px;
      background-color: #4da5ff;
      color: #fff;
      border-radius: 5px;
      font-size: 12px;
      cursor: pointer;
      a {
        position: relative;
        z-index: -1;
      }
    }
  }
}
// 物流轨迹
.wuliu-guiji {
  width: 100%;
  height: 450px;
  background: #fafafa;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
  .box-in {
    height: auto;
    .wl_tit {
      margin-bottom: 20px;
      .wuliu-title {
        font-size: 18px;
        font-weight: 550;
        color: #666666;
        float: left;
      }
      .sy_fr {
        float: right;
      }
    }
    .wuliu-new {
      display: flex;
      color: #8c8c8c;
      .wuliu-new-top {
        min-width: 142px;
      }
      ul {
        margin-left: 10px;
        li {
          line-height: 24px;
        }
      }
    }
  }
}
.sy_ww {
  font-size: 20px;
  text-align: center;
  min-height: 200px;
}
.exportBox .export {
  position: absolute;
  top: 200px;
  right: 100px;
  width: 80px;
  height: 30px;
  line-height: 30px;
  background-color: #409eff;
  padding: 1px;
  border-radius: 6px;
  color: #fff;
  text-align: center;
}
</style>
